import css from './BalloonWrapper.module.scss'
import React, { PropsWithChildren } from 'react'
import classNames from 'classnames'

import { BalloonBgPosition, BalloonSize, BalloonTipPosition, ComponentColor } from 'meta/backendControlled/structure'
import {
  TICKETSMS_COLORS_BLACK,
  TICKETSMS_COLORS_BLUE,
  TICKETSMS_COLORS_LIGHTYELLOW,
  TICKETSMS_COLORS_RED,
  TICKETSMS_COLORS_RED_LIGHT,
} from 'utils/constants/colors'

import Img from 'components/Media/Img'

interface IPropsBalloon {
  backgroundUrl?: string
  backgroundPosition?: BalloonBgPosition
  className?: string
  color: ComponentColor
  containsMenu?: boolean
  containsShowcase?: boolean
  insideVerticalScroll?: boolean
  removePaddingOutside?: boolean
  size: BalloonSize
  tipPosition: BalloonTipPosition
  noPadding?: boolean
}

const BalloonWrapper: React.FC<PropsWithChildren<IPropsBalloon>> = (props) => {
  const {
    backgroundUrl = undefined,
    backgroundPosition,
    children,
    className,
    containsMenu,
    color,
    insideVerticalScroll = false,
    size,
    tipPosition,
    noPadding = false,
  } = props

  const getBgColor = (color: ComponentColor) => {
    switch (color) {
      case ComponentColor.black:
        return TICKETSMS_COLORS_BLACK
      case ComponentColor.blue:
        return TICKETSMS_COLORS_BLUE
      case ComponentColor.red:
        return TICKETSMS_COLORS_RED
      case ComponentColor.redLight:
        return TICKETSMS_COLORS_RED_LIGHT
      case ComponentColor.yellow:
        return TICKETSMS_COLORS_LIGHTYELLOW
      default:
        return ComponentColor.white
    }
  }

  const getExtension = (color: ComponentColor) => {
    switch (color) {
      case ComponentColor.blue:
      case ComponentColor.red:
      case ComponentColor.redLight:
      case ComponentColor.yellow:
        return 'svg'
      default:
        return 'png'
    }
  }

  const bgColor = getBgColor(color)
  const extension = getExtension(color)
  const background = `linear-gradient(to bottom, rgba(0, 0, 0, 0) 0%, ${bgColor}aa 65%, ${bgColor} 100%), url('${backgroundUrl}') no-repeat`

  //TODO: check whether this can be calculated differently
  const contentId =
    insideVerticalScroll &&
    children &&
    // @ts-expect-error might not exist
    children[0] &&
    // @ts-expect-error might not exist
    children[0].props &&
    // @ts-expect-error might not exist
    children[0].props.children &&
    // @ts-expect-error might not exist
    children[0].props.children.props &&
    // @ts-expect-error might not exist
    children[0].props.children.props.data &&
    // @ts-expect-error might not exist
    children[0].props.children.props.data.title
      ? // @ts-expect-error might not exist
        children[0].props.children.props.data.title.toLowerCase()
      : null

  return (
    <div
      className={classNames(css.balloonContainer, className, {
        // [css.small]: size === BalloonSize.small,
        // [css.no_padding]: removePaddingOutside,
      })}
    >
      <div
        id={contentId ?? undefined}
        className={classNames(css.balloon, css[`balloonColor_${color}`], css[`balloonTip_${tipPosition}`], {
          [css.containsMenu]: containsMenu,
          [css.nopadding]: noPadding,
          [css.medium]: size === BalloonSize.medium,
        })}
        style={backgroundUrl ? { background, backgroundSize: 'cover', backgroundPosition } : undefined}
      >
        {React.Children.toArray(children)}
      </div>

      <div
        className={classNames(css[`balloonTipContainer_${tipPosition}`], {
          [css.medium]: size === BalloonSize.medium,
          [css.small]: size === BalloonSize.small,
        })}
      >
        <Img src={`/baloon/tip_${color}_${tipPosition}.${extension}`} />
      </div>
    </div>
  )
}

export default BalloonWrapper
